import type {GetServerSideProps, GetServerSidePropsResult} from 'next';
import {
  type GetUserDataForAnalyticsResponseType,
  getUserDataForAnalytics,
} from '../../core/repositories/usersMeRepository';
import {validateCookie} from '../../core/usecases/auth/checkOauthTokenExistence';
import {DisclaimerPage} from '../../features/disclaimer/components/DisclaimerPage';
import {withHandler} from '../../server/token/withHandler';
import {ScriptForGA} from '../../shared/components/ScriptForGA';
import {NoLeftSidebarLayout} from '../../shared/components/layouts/NoLeftSidebarLayout';
import type {NextPageWithLayout} from '../_app';

type Props = {
  userDataForAnalytics?: GetUserDataForAnalyticsResponseType;
};

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withOptionalSession'
>(
  {auth: 'optional'},
  async (context): Promise<GetServerSidePropsResult<Props>> => {
    const {cookies} = context.req;
    const {isValid} = validateCookie(cookies);
    if (!isValid) {
      return {
        props: {},
      };
    }

    const userDataResponse = await getUserDataForAnalytics({cookies});
    if (!userDataResponse.ok) {
      return {
        props: {},
      };
    }

    return {
      props: {
        userDataForAnalytics: userDataResponse.value,
      },
    };
  },
);

const Page: NextPageWithLayout<Props> = ({userDataForAnalytics}: Props) => {
  return (
    <>
      <DisclaimerPage />
      <ScriptForGA userDataForAnalytics={userDataForAnalytics} />
    </>
  );
};

export default Page;

Page.getLayout = (page) => <NoLeftSidebarLayout>{page}</NoLeftSidebarLayout>;
